import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { IValidateUrl } from './validate-url.interface';
import { IRegistration } from './registration.interface';
import { IOktaRegistrationEligibilityResponse } from './okta-registration.interface';

@Injectable({
  providedIn: 'root'
})
export class RegistrationService {

  constructor(
    private _http: HttpClient) { 
  }


  public registerUser(formValues: IRegistration) {
    return this._http.post(
        environment.registrationApi + 'registration', 
        this._encodeData(formValues),
        {
          headers: new HttpHeaders({
            'Content-Type':  'application/x-www-form-urlencoded',
          })
        })
      .pipe(
        catchError((error) => { return throwError(() => error); }
      ));

  }

  public getUserAgreement() {
    return this._http.get(environment.registrationApi + 'agreement')
      .pipe(
        catchError((error) => { return throwError(() => error); }
      ));

  }

  public validateUrl(token: string) {
    return this._http.post<IValidateUrl>(environment.registrationApi + 'validateUrl', {
      'token': token
    })
      .pipe(
        catchError((error) => { return throwError(() => error); }  
      ));

  }

  public checkRegistrationEligibility(email: string): Observable<IOktaRegistrationEligibilityResponse> {
    return this._http.post<IOktaRegistrationEligibilityResponse>(
      environment.registrationApi + 'okta/registration',
      { Email: email },
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        })
      }
    ).pipe(
      map((response) => {
        if (!response?.result) {
          return response;
        }

        const resultWithLegacyCase = response.result as typeof response.result & { USER?: typeof response.result.user };
        return {
          ...response,
          result: {
            ...response.result,
            user: response.result.user || resultWithLegacyCase.USER,
          }
        };
      }),
      catchError((error) => { return throwError(() => error); }
    ));
  }

  private _encodeData(formValues : object) {
    // Turn the data object into an array of URL-encoded key/value pairs.
    let urlEncodedDataPairs = [];

    for (const [key, value] of Object.entries(formValues)) {
      urlEncodedDataPairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value == null ? '' : String(value)));
    }

    // Combine the pairs into a single string and replace all %-encoded spaces to 
    // the '+' character; matches the behaviour of browser form submissions.
    return urlEncodedDataPairs.join('&').replace(/%20/g, '+');
  }


}
